module.exports = __webpack_public_path__ + "images/f4d44a4b6095662e7e557ddf5d81c793.png";